export default __webpack_public_path__ + "static/icon-size-down-cbe84c3347848524605365aa05ec9535.webp";